import { render, staticRenderFns } from "./AddNe.vue?vue&type=template&id=087f959a&"
import script from "./AddNe.vue?vue&type=script&lang=js&"
export * from "./AddNe.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports